"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areAllPropertiesNotNullOrEmpty = void 0;
var areAllPropertiesNotNullOrEmpty = function (obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var value = obj[key];
            // Check if the value is null or empty
            if (value === null || value === undefined || value === "") {
                return false;
            }
        }
    }
    // If all properties are not null or empty
    return true;
};
exports.areAllPropertiesNotNullOrEmpty = areAllPropertiesNotNullOrEmpty;
